import React, { useEffect, useState } from "react";
import PasswordInput from "../elements/passwordInput/PasswordInput";
import PasswordValidator from "../elements/passwordInput/PasswordValidator";
import DefaultButton from "../styles/materialButtonStyle";

import { StyledForm, StyledFormAction, StyledFormContent } from "../styles/styledForm";

const ResetPasswordForm = ({ t, handleSubmit, loading, error, setError }) => {

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (password !== confirmPassword) {
      setError(current => { return { ...current, confirmNewPassword: t("resetPassword.passwordsDoNotMatch") }});

      return;
    }

    setError(current => {
      const { confirmNewPassword, ...rest } = current;

      return rest;
    });
  }, [confirmPassword, password]);

  return (
    <>
      <StyledForm
        onSubmit={handleSubmit}
        className="login-form"
      >
        <StyledFormContent className="login-form__content">
          <PasswordInput
            label={t("resetPassword.newPassword")}
            error={error.newPassword}
            id="newPassword"
            className="login-form__input"
            name="password"
            setPasswordRef={setPassword}
          />
          <PasswordValidator
            password={password}
            passwordErrors={error}
            setPasswordErrors={setError}
            t={t}
          />
          <PasswordInput
            label={t("resetPassword.confirmNewPassword")}
            error={error.confirmNewPassword}
            id="confirmNewPassword"
            className="login-form__input"
            name="password"
            setPasswordRef={setConfirmPassword}
          />
        </StyledFormContent>
        <StyledFormAction className="login-form__action">
          <DefaultButton
            color="success"
            type="submit"
            disabled={loading || Object.keys(error).filter(item => error[item] !== true).length > 0}
          >
            {t("submit")}
          </DefaultButton>
        </StyledFormAction>
      </StyledForm>
    </>
  );
};

export default ResetPasswordForm;